<template>
  <v-row>
    <v-col cols="6">
      <v-autocomplete
        :items="stops"
        :rules="[required]"
        item-value="short_name"
        :item-text="item => `(${item.short_name}) ${item.stop_name}`"
        :filter="
          (item, query) =>
            item.short_name.toLowerCase().includes(query.toLowerCase()) ||
            item.stop_name.toLowerCase().includes(query.toLowerCase())
        "
        outlined
        label="Från"
        v-model="model.from"
      />
    </v-col>
    <v-col cols="6">
      <v-autocomplete
        :items="stops"
        :rules="[required]"
        item-value="short_name"
        :item-text="item => `(${item.short_name}) ${item.stop_name}`"
        :filter="
          (item, query) =>
            item.short_name.toLowerCase().includes(query.toLowerCase()) ||
            item.stop_name.toLowerCase().includes(query.toLowerCase())
        "
        outlined
        label="Till"
        v-model="model.to"
      />
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { get, sync } from 'vuex-pathify'

export default {
  name: 'ReplacementFromToField',

  data: () => ({
    required
  }),

  computed: {
    stops: get('event/stops'),
    model: sync('replacement/model')
  }
}
</script>
